import React from 'react';
import SendEmailForm from '../forms/SendEmailForm';
import EmailListViewer from './EmailListViewer';
import { EmailMessageDTO } from '../../services/apiClient';
import { DrawerViewConstants } from '../../constants/DrawerViewConstants';

interface EmailDrawerContentProps<T> {
  drawerView: string | undefined;
  selectedItem: T | undefined;
  componentId: string;
  getMemberId: (item: T | undefined) => string;
  onEmailSubmit: (data: EmailMessageDTO) => Promise<void>;
  onClose: () => void;
  isSending: boolean;
}

const EmailDrawerContent = <T extends { id?: string }>({
  drawerView,
  selectedItem,
  componentId,
  getMemberId,
  onEmailSubmit,
  onClose,
  isSending,
}: EmailDrawerContentProps<T>): React.ReactElement | null => {
  if (drawerView === DrawerViewConstants.SEND_EMAIL) {
    return (
      <SendEmailForm
        memberId={getMemberId(selectedItem)}
        recordId={selectedItem?.id || ''}
        componentId={componentId}
        onSubmit={onEmailSubmit}
        onCancel={onClose}
        isLoading={isSending}
      />
    );
  }

  if (drawerView === DrawerViewConstants.VIEW_ALL_EMAIL_LIST) {
    return <EmailListViewer componentId={componentId} memberId={getMemberId(selectedItem)}/>;
  }

  if (drawerView === DrawerViewConstants.VIEW_RECORD_EMAIL_LIST) {
    return <EmailListViewer componentId={componentId} memberId={getMemberId(selectedItem)} recordId={selectedItem?.id} />;
  }

  return null;
};

export default EmailDrawerContent;
